import type { PendingOrder } from '@/types/pendingOrder';
import { handleLocalStorage } from './handleLocalStorage';

export function readPendingOrder(): PendingOrder | undefined {
  try {
    const stored: unknown = handleLocalStorage.get('order_confirm');
    const order = typeof stored === 'string' ? JSON.parse(stored) : stored;
    if (!order || typeof order !== 'object' || Array.isArray(order)) return;
    if (!['order_id', 'order_codeTracking', 'slug', 'payment_status'].every(
      key => typeof order[key] === 'string' && order[key].trim().length > 0,
    )) return;
    return order as PendingOrder;
  } catch {
    return;
  }
}

export function removePaidPendingOrder(order: {
  id?: string; codeTracking?: string; paymentStatus?: string;
}) {
  if (order.paymentStatus !== 'PAID' || !order.id || !order.codeTracking) return;
  try {
    const pending = readPendingOrder();
    if (pending?.order_id === order.id && pending.order_codeTracking === order.codeTracking) {
      handleLocalStorage.remove('order_confirm');
    }
  } catch {
    // Storage may be disabled; the API remains the source of payment status.
  }
}

// A returned OnePay attempt must not be restored as an unfinished checkout.
// Only remove its own record: another tab may already have created a new order.
export function removeOnePayPendingOrder(order: Pick<PendingOrder, 'order_id' | 'order_codeTracking' | 'code'>) {
  try {
    const pending = readPendingOrder();
    if (pending?.paymentType === 'ONEPAY' && pending.order_id === order.order_id &&
      pending.order_codeTracking === order.order_codeTracking && pending.code === order.code) {
      handleLocalStorage.remove('order_confirm');
    }
  } catch {
    // Storage may be disabled. Never change the backend payment status here.
  }
}
